import { Component, OnInit, Input , Output,  OnDestroy , EventEmitter} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { Argument } from './argument.model';
import { Dropdown } from './../../../../_models/drpdown';
import { ArgumentService } from './argument.service';
import { arraysAreNotAllowedMsg } from '@ngrx/store/src/models';

@Component({
  selector: 'app-argument',
  templateUrl: './argument.component.html',
  styleUrls: ['./argument.component.scss']
})
export class ArgumentComponent implements OnInit , OnDestroy {
  valores = [];

  @Input() arg: Argument;
  @Input() form: FormGroup;
  @Input() submitted: boolean;
  @Input() readonly: false;
  @Input() sections: any[];
  source: Array<Dropdown>;
  data: Array<Dropdown> = new Array<Dropdown>();
  loadDataList:boolean = false;
  loadingList =  false; // cargando lista ...

  subscriptionArgumentService: Subscription;
  subscriptionValueChange: Subscription;

  rangeYearCalendar: any ;

  constructor(  private formBuilder: FormBuilder,
                private argumentService: ArgumentService
    ) {      
    }

  ngOnInit() {
    //console.log('Creando Argumento: ', this.arg.argid);
    //console.log('Valor formulario' , this.form);
  // carga de datos de los argumentos tipo List 

    if (this.arg.argdesc === null) {
      this.arg.argdesc = "";
    }
    if (this.arg.argtype === 'sdc' || this.arg.argtype === 'ddsdc') {
      // this.onGetArgumentSDC(this.arg.sdcid); 
    } else if (this.arg.argtype === 'ddsql' || this.arg.argtype === 'sqllookup') {
      this.onGetArgumentSQL(this.arg.argdata);
    } else if (this.arg.argtype === 'reftype') {
      this.onGetArgumentRefType(this.arg.reftypeid);
    }
    this.loadDataList = true; // listas cargadas , solo estan pendientes listas cascadas
    this. getDataListaCascadeByChange();
    this.getDataListaCascadeInitial();

    this.argumentService.getPolicy().subscribe((resp: any) => {     
      this.rangeYearCalendar  =  resp.policy.calendar.rangeyeararguments; 
      //console.log('policy recibida', resp) ;         
    }, err => {
    });; 
  }

  getDataListaCascadeByChange() {
    // console.log('Carga automatica por cambio en argumento: ' + arg);
    // replaza al evento : (open)="onGetArgumentSQL(arg.argdata)"
    // de los combos del tipo arg.argtype === 'ddsql'

    // console.log('Desde ' + this.arg.argid + ', Ultimo control que cambio: ', this.form['controlchanged']);

    let sql = this.arg.argdata ;
    if (sql) {
      let elementsOrigin = sql.match(/(\[[^\]]+])/g);
     // if (elements !== null && this.form.controls[this.arg.argid].status !== 'VALID') {
      if (elementsOrigin !== null) {
         // eliminar duplicados
        let elements = elementsOrigin.filter((item, index ) => {
          return elementsOrigin.indexOf(item) === index;
        });

        elements.forEach(e => {
          const re = /\[|\]/g;
          const argid = e.replace(re, '');
          if (argid !== 'SYSUSERID' && argid !== 'LOGON_NAME' ) {

             console.log(`Soy ${this.arg.argid} y me subcribo a ${argid}`);

             this.subscriptionValueChange = this.form.get(argid).valueChanges.subscribe(
              () => { 
                let invalidos = false;
               // console.log(`Soy ${this.arg.argid} y cambio: ${argid}: ` + this.form.get(argid).value.value) ;
               // console.log('Valor objeto' , this.form.get(argid));
                // limpio el control a razon de cambio de valor en parametro asociado
                this.form.controls[this.arg.argid].setValue(undefined);
                // si el valor del parametro que cambio es invalido, cmbio a null y es requerido
                if (this.form.controls[argid].status === 'INVALID') {
                      // limpiar listas de los combos
                      this.data = [];
                      this.source = this.data.slice();
                     // invalidos = true;
                      return;
                }
                // si el valor del parametro que cambio es valido
                let sql = this.arg.argdata ;
                let elements = sql.match(/(\[[^\]]+])/g);
                // verificar si todos lo parametros asociados son validos
                elements.forEach( e => {
                  const re = /\[|\]/g;
                  const argid = e.replace(re, '');
                  if (argid !== 'SYSUSERID' && argid !== 'LOGON_NAME' ) {
                    // si al menos uno de los parametros es invalido no carga la lista
                   // console.log(argid , this.form.controls[argid].status);
                    if (this.form.controls[argid].status === 'INVALID') {
                       invalidos = true;
                       return;
                    }
                  }
                });
                  // todos los parametros asociados son validos
                if (!invalidos) {
                     console.log('Ejecutar consulta de: ' + this.arg.argid );
                     this.onGetArgumentSQL(this.arg.argdata);
                  }
              }, (err) => {
                console.log('error en subcripcion de servicio' , err);
              }
            );
           }
        });
      }
    }
  }

  get isValid() { return this.form.controls[this.arg.argid].valid; }

  onGetArgumentSDC(sdcid: string) {
   // console.log(`ArgumentComponent: Init onGetArgumentSDC: ${sdcid}`);
    // console.log('Estado: ' + this.arg.argid , this.subscriptionArgumentService);

    this.subscriptionArgumentService = this.argumentService
      .onGetArgumentSDC(sdcid)
      .subscribe(
        (record: Dropdown[]) => {
          this.data = record;
          this.source = this.data.slice();
        }
      );
   // console.log(`ArgumentComponent: End onGetArgumentSDC: ${sdcid}`);
  }

  onGetSqlWithParameters(sql: string, elements: any[]) {
    //console.log("Initial sql " , sql);
   // console.log("elements " + elements.length , elements);
    let value = "";
    const re = /\[|\]/g;
    elements.forEach(e => {
      const argid = e.replace(re, '');
      if (argid === 'SYSUSERID') {
        value = sessionStorage.getItem("sysUserId"); //JSON.parse(sessionStorage.getItem('user'));
      }else if(argid === 'LOGON_NAME'){
        value = sessionStorage.getItem("logonName");
      } else {
        // console.log('Valor del argumento a remplazar en query: ' +  typeof (this.form.controls[argid].value) , this.form.controls[argid].value )
        let source = this.form.controls[argid].value;  /// {text, value}

        // validacion para valor fecha. devuelve objetos en fechas.nav-group-item
        if (Object.prototype.toString.call(source) === '[object Date]') {
          let day = "";
          let month = "";
          source = `${day !== "" ? day : new Date(source).getDate()}/${month !== "" ? month : new Date(source).getMonth()+1}/${new Date(source).getFullYear()}`;
        }
        value = this.onGetValueOfArguments(source);
      }
      sql = sql.replace(e, value);
    });
    // console.log("final sql " , sql);
    return sql;
  }

  onGetValueOfArguments(source: any) {
   // console.log('onGetValueOfArguments: ' + typeof (source) , source);
   if(source !== undefined && source !== null) {
    if(!Array.isArray(source)){
      // source = typeof (source) === 'string' ? source : source.value;
      switch (typeof (source)) {
        case 'string':
          break;
        case 'number':
          break;
        default:
          source = source.value;
          break;
      }
    }
    let value = '';
    // console.log('onGetValueOfArguments, --> before switch ' + typeof (source) , source);
    switch (typeof (source)) {
      case 'string':
        value = `${source}`;
        break;
      case 'number':
        // console.log('onGetValueOfArguments, --> type: ' + typeof (source) , source);
        value = `${source}`;
        break;
      case 'object':
        source.forEach(element => {
          value = `${value},'${element.value}'`;
        });
        value = value.substring(1);
        break;
      default:
        // console.log('onGetValueOfArguments: --> default: ' + typeof (source) , source);
        break;
    }
    // console.log('Valor Salida: ', value)

    return value;
   }
    return null;
  }

  onChangeArgumentSQL(argchanged: string , sections: any[]) {
  // deprecate: se remplaza funcionalidad con manejo de cambios a nivel de controles del formulario (valuechanged)

    // // console.log('modificacion en argumento: ' ,  argchanged);
    // this.form['controlchanged'] = argchanged;
    // for (const section of sections) {
    //   for (const items of section.args) {
    //       for (const arg of items.group) {
    //         const sql: string = arg.argdata ;
    //         if (sql !== null) {
    //           const re = /\[|\]/g;
    //           const elements = sql.match(/(\[[^\]]+])/g);
    //           if (elements !== null) { // listas dependientes cascada
    //             elements.forEach(e => {
    //               const argid = e.replace(re, '');
    //               if (argchanged === argid) {
    //                 // limpiar argumentos asociados
    //                 // console.log('Limpiar componente: ' + arg.argid + ' por modificacion en: ' + argchanged);
    //                 this.form.controls[arg.argid].setValue(undefined);
    //                 this.onChangeArgumentSQL(arg.argid, sections);
    //               }
    //              });
    //            }
    //          }
    //      }
    //   }
    // }
  }

  onGetArgumentSQL(sql: string) {
    //console.log('ejecutar carga');
    // console.log(this.loadDataList + ` ArgumentComponent: Init onGetArgumentSQL: ${sql}`);
    const elements = sql.match(/(\[[^\]]+])/g);
    if (elements !== null && this.loadDataList) {
      sql = this.onGetSqlWithParameters(sql, elements);
      // console.log(`Consulta final filtrada: Init onGetArgumentSQL: ${sql}`);
      this.getDataService (sql);
    }

    if (!this.loadDataList && elements === null) {  // listascargadas? false
      // solo se carga la primera vez
      // no es posible la desactivacion, ya que un argumento puede tener otros argumentos que pueden ser o no requeridos. 
      // No es factible su ejecucion. rpr 03122019
      //  console.log('Carga Inicial', this.arg.argid);
         this.getDataService (sql);
    }
  }

  getDataService(sql: string) {
    // cancelar subscripciones en proceso
    if (this.subscriptionArgumentService) {
      // console.log('Cancelar subscripcion activa de: ' + this.arg.argid  , this.subscriptionArgumentService );
      this.subscriptionArgumentService.unsubscribe();
    }
    //
    this.loadingList = true;
    this.subscriptionArgumentService = this.argumentService
    .onGetArgumentSQL(sql)
    .subscribe(
      (record: Dropdown[]) => {
       //  console.log('record ', record)
        this.data = record;
        this.source = this.data.slice();
        this.loadingList = false;
      }
    );
  }

  onGetArgumentRefType(ref: string) {
    // cancelar subscripciones en proceso
    if (this.subscriptionArgumentService) {
      this.subscriptionArgumentService.unsubscribe();
    }
    //

    this.loadingList = true;
    this.subscriptionArgumentService = this.argumentService
    .onGetArgumentRefType(ref)
    .subscribe(
      (record: Dropdown[]) => {
        this.data = record;
        this.source = this.data.slice();
        this.loadingList = false;
      }
    );
  }

  public filterChange(filter: any): void {
    this.data = this.source.filter((s) => s.text.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  public getDataListaCascadeInitial() {
    // si todos lo argumentos dependientes son validos ejecutar carga de lista
    let invalidos = false;
    const sql = this.arg.argdata ;
    if (sql) {
      const elementsOrigin = sql.match(/(\[[^\]]+])/g);
      if (elementsOrigin !== null) {
        const elements = elementsOrigin.filter((item, index ) => {
          return elementsOrigin.indexOf(item) === index;
        });
        // verificar si todos lo parametros asociados son validos
        elements.forEach( e => {
          const re = /\[|\]/g;
          const argid = e.replace(re, '');
          if (argid !== 'SYSUSERID' && argid !== 'LOGON_NAME' ) {
            // si al menos uno de los parametros es invalido no carga la lista
            console.log(argid , this.form.controls[argid].status);
            if (this.form.controls[argid].status === 'INVALID') {
               invalidos = true;
               return;
            }
          }
        });
          // todos los parametros asociados son validos
        if (!invalidos) {
             console.log('Ejecutar consulta de: ' + this.arg.argid );
             this.onGetArgumentSQL(this.arg.argdata);
          }
      }
    }
  }

  ngOnDestroy() {
    if (this.subscriptionArgumentService) {
      this.subscriptionArgumentService.unsubscribe();
    }
    if(this.subscriptionValueChange) {
      this.subscriptionValueChange.unsubscribe();
    }
  }



}
